import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface JobPostQuestion {
  question: string;
  required?: boolean;
  displayOrder?: number;
}

export interface CreateJobPostRequest {
  jobPostTitle: string;
  positionTitle: string;
  jobLevel: string;
  postType: string; // "JOB" | "INTERNSHIP"
  jobType: string;
  jobStatus: string;
  collarType?: string | null; // "BLUE_COLLAR" | "WHITE_COLLAR"
  categories?: string[] | null; // list of category strings
  workplace: string;
  country: string;
  city: string;
  minExperience: number | null;
  maxExperience: number | null;
  minSalary: number | null;
  maxSalary: number | null;
  currency?: string | null; // "EGP" | "USD" | etc.
  salaryType?: string | null; // "PER_MONTH" | "PER_YEAR" | "PER_DAY" | "PER_HOUR"
  hideSalary: boolean;
  additionalSalaryDetails?: string | null;
  numberOfVacancies: number;
  maxApplicants?: number | null;
  deadline: string;
  jobDescription: string;
  skillsAndTools: string[];
  applicationMethod: string; // "SINGLE_APPLY" | "EXTERNAL_LINK"
  externalLink?: string | null;
  requirements?: string[] | null;
  benefits?: string[] | null;
  responsibilities?: string[] | null;
  questions?: JobPostQuestion[] | null;
}

@Injectable({
  providedIn: 'root',
})
export class JobPostService {
  private readonly baseUrl = environment.apiUrl;


  constructor(private http: HttpClient) {}
private get userId(): string {
  return localStorage.getItem('userId') || '';
}
  createJobPost(jobPost: CreateJobPostRequest): Observable<any> {
    return this.http.post(
      `${this.baseUrl}api/job-posts/company/${this.userId}`,
      jobPost,
    );
  }

getJobPosts(
  page = 0,
  size = 10,
  filters?: { jobTypes?: string; position?: string; workplaces?: string },
): Observable<any> {
  const companyId = this.userId;
  let url = `${this.baseUrl}api/job-posts/company/${companyId}?page=${page}&size=${size}`;
  if (filters?.jobTypes)   url += `&jobTypes=${encodeURIComponent(filters.jobTypes)}`;
  if (filters?.position)   url += `&position=${encodeURIComponent(filters.position)}`;
  if (filters?.workplaces) url += `&workplaces=${encodeURIComponent(filters.workplaces)}`;
  return this.http.get(url);
}

  deleteJob(jobId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}api/job-posts/${jobId}`);
  }

  getJobById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}api/job-posts/${id}`);
  }

  updateJobPost(id: string, jobPost: CreateJobPostRequest): Observable<any> {
    return this.http.put(`${this.baseUrl}api/job-posts/${id}`, jobPost);
  }
 searchJobPosts(
  search: string,
  page = 0,
  size = 10,
): Observable<any> {
  const companyId = this.userId;
  return this.http.get(
    `${this.baseUrl}api/job-posts/company/${companyId}/search?search=${encodeURIComponent(search)}&page=${page}&size=${size}`,
  );
}
}
